import type { ComponentType } from 'react';
import {
  Home20Regular,
  Apps20Regular,
  Settings20Regular,
  Library20Regular,
  BoxMultiple20Regular,
} from '@fluentui/react-icons';
import { isFeatureEnabled } from '@/featureFlags';

export interface ProjectNavItem {
  id: string;
  label: string;
  icon: ComponentType;
  /** Relative path from the project layout (e.g., './apps', './settings') */
  path: string;
  /** If true, NavLink uses exact (`end`) matching — required for `/` style absolute home links. */
  end?: boolean;
}

export interface ProjectNavSection {
  id: string;
  /** When omitted, the section renders unlabelled and without a divider. */
  label?: string;
  /** Optional icon rendered to the left of the section heading text. */
  icon?: ComponentType;
  items: ProjectNavItem[];
}

export const projectNavSections: ProjectNavSection[] = [
  {
    id: 'home',
    items: [
      { id: 'home', label: 'Home', icon: Home20Regular, path: '/', end: true },
    ],
  },
  // Single project-scoped section. ProjectLayout overrides `label` with the
  // current project name and supplies the folder icon at runtime — the static
  // "Project" label here is only the fallback used before the project loads.
  {
    id: 'project',
    label: 'Project',
    items: [
      { id: 'apps', label: 'Apps', icon: Apps20Regular, path: './apps' },
      ...(isFeatureEnabled('knowledgeManagement') ? [{ id: 'knowledge', label: 'Knowledge', icon: Library20Regular as ComponentType, path: './knowledge' }] : []),
      { id: 'sandboxes', label: 'Sandboxes', icon: BoxMultiple20Regular, path: './sandboxes' },
      { id: 'settings', label: 'Settings', icon: Settings20Regular, path: './settings' },
    ],
  },
];

/** Flat list derived from sections — backward compat */
export const projectNavItems: ProjectNavItem[] = projectNavSections.flatMap((s) => s.items);
